import React, { memo } from "react";
import useStyles from "./styles";
import ImagesConfig from "components/ImagesConfig";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const PromotionItem = memo(props => {
	const classes = useStyles();
	const { giftByPromotion } = props;

	return (
		<Grid style={{ marginTop: 10 }}>
			{giftByPromotion.products.map((product, index) => (
				<Grid key={index} classes={{ root: classes.root }}>
					<Grid classes={{ root: classes.customImage }}>
						<ImagesConfig
							image={product?.image}
							imageDefault={Images.icProductDefault}
							width={80}
							height={80}
						/>
						<Grid classes={{ root: classes.name }}>
							{product?.productName}
						</Grid>
					</Grid>
					<Grid classes={{ root: classes.quantity }}>
						<Grid style={{ marginLeft: 10 }}>
							x{product?.quantity}
						</Grid>{" "}
						<Grid>Lẻ</Grid>
					</Grid>
				</Grid>
			))}
		</Grid>
	);
});

export default PromotionItem;
